import { RouteObject } from 'react-router';

import { ProtectedCanRoute } from '@barboxx/admin-components';

import { PlaceCreate } from './Create';
import { PlaceDetails } from './Details';
import { PlacesList } from './List';

export const PLACES_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: PlacesList,
    },
    {
        path: 'create',
        // Component: PlaceCreate,
        element: (
            <ProtectedCanRoute abilityAction="create" subject="Place">
                <PlaceCreate />
            </ProtectedCanRoute>
        ),
    },
    {
        path: ':id',
        Component: PlaceDetails,
    },
];
